var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CardButton, SimpleCard, Typography } from '@pinwheel/origami';
import React from 'react';
var fontConfiguration = {
    homemade_apple: {
        fontFamily: 'HomemadeApple',
        fontSize: '24px',
        fontWeight: 400,
        lineHeight: '24px',
        letterSpacing: '0em',
    },
    sunshiney: {
        fontFamily: 'Sunshiney',
        fontSize: '32px',
        fontWeight: 400,
        letterSpacing: '0em',
    },
    caveat: {
        fontFamily: 'Caveat',
        fontSize: '32px',
        fontWeight: 400,
        lineHeight: '32px',
        letterSpacing: '0em',
    },
};
var FontCard = function (props) {
    if (props.onClick) {
        return (React.createElement(CardButton, __assign({}, props, { "data-testid": props['data-testid'], eventId: props.eventId, sx: __assign({ '& p': fontConfiguration[props.signatureStyle] }, props.sx), color: "default", disabled: props.disabled }), props.displayText));
    }
    return (React.createElement(SimpleCard, { tabIndex: undefined, "data-testid": props['data-testid'], eventId: props.eventId, sx: __assign({ padding: '24px 16px', boxSizing: 'border-box', '& p': fontConfiguration[props.signatureStyle] }, props.sx) },
        React.createElement(Typography, { align: "center", variant: "label" }, props.displayText)));
};
export default FontCard;
